import { useGet, usePut } from '../../../sharedModules/hooks/useQuery';
import { WarehouseLabelConfigPayload, warehouseLabelConfigsUrl } from '../model';

export function useWarehouseLabelConfigs(location: string) {
  return useGet<WarehouseLabelConfigPayload>({
    url: warehouseLabelConfigsUrl,
    params: { location },
    enabled: !!location,
  });
}

// A save returns the whole payload, not just the saved template: assigning a department
// moves it out of another template, so two templates change on one write.
export function useSaveWarehouseLabelTemplate() {
  return usePut<WarehouseLabelConfigPayload>();
}
